import newRelicAgent from '../new-relic';

const IGNORED_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications.',
  (error) => error?.name === 'LaunchDarklyFlagFetchError',
  (error) => error?.stack?.includes('chrome-extension://'),
];

// Exports
// -------

export default function logError(error, customAttributes) {
  const isIgnored = IGNORED_ERRORS.some((ignoredError) => {
    if (typeof ignoredError === 'function') {
      return ignoredError(error);
    }

    const errorMessage = error instanceof Error ? error.message : error;

    if (typeof errorMessage === 'string') {
      return errorMessage.includes(ignoredError);
    }

    return false;
  });

  if (isIgnored) {
    console.log('Ignored Error:', error, customAttributes);

    return;
  }

  newRelicAgent.noticeError(error, customAttributes);
}
